<div fxLayout="column" fxLayoutAlign="space-around center">
  <span class="mt-20 mb-10 title">{{data.title}}</span>
  <span class="p-1 text-center">{{data.modalMessage}}</span>
  <div mat-dialog-actions class="w-100"  fxLayout="row" fxLayoutAlign="space-evenly center">
    <ng-container [ngTemplateOutlet]="btn" [ngTemplateOutletContext]="{ type: data.type }"></ng-container>
    <button  mat-raised-button color="primary" (click)="onCancelClick()" cdkFocusInitial>Cancel</button>
  </div>
</div>

<ng-template #btn let-type="type">
  <span [ngSwitch]="type">
    <span *ngSwitchCase="ModalType.DELETE"> <ng-container [ngTemplateOutlet]="btnDelete"></ng-container> </span>
    <span *ngSwitchCase="ModalType.CONFIRM"> <ng-container [ngTemplateOutlet]="btnConfirm"></ng-container> </span>
  </span>
</ng-template>


<ng-template #btnDelete>
  <button mat-stroked-button color="warn" [mat-dialog-close]="true" (click)="openSnackBar()">Eliminar</button>
</ng-template>

<ng-template #btnConfirm>
  <button mat-stroked-button color="primary" [mat-dialog-close]="true" (click)="openSnackBar()">Confirmar</button>
</ng-template>


